@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.root {
  padding: 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
  cursor: pointer;

  &:hover {
    background-color: var(--surface-hover);
  }

  &:first-child:hover {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-child:hover {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}

.headerWrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 12px;
}

.assetDetailsWrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.assetNameWrapper {
  display: flex;
  flex-direction: column;
}

.assetNameLabel {
  @include typography-v2-title-base;
}

.assetTickerLabel {
  @include typography-v2-body-xs;
  color: var(--text-soft);
}

.priceChangeContainer {
  display: flex;
  gap: 8px;
  font-family: var(--font-roboto-mono);
}

.priceChangeContainerDefault {
  color: var(--text-soft);
}

.priceChangeContainerNegative {
  color: var(--viz-bearish);
}

.priceChangeContainerPositive {
  color: var(--viz-bullish);
}

.flexWrapper {
  display: flex;
  gap: 8px;
}

.priceChangeWrapper {
  @include typography-v2-body-xs;
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--text-soft);
}

.dateLabel {
  @include typography-v2-body-xs;

  color: var(--text-soft);

  &.pre {
    color: var(--text-primary);
  }

  &.open {
    color: var(--text-primary);
  }

  &.after {
    color: var(--text-soft);
  }
}

.earningsSection {
  @include border-radius-r2;
  background-color: var(--surface-default);
  padding: 8px 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.earningsSectionReported {
  margin-bottom: 24px;
}

.earningsDateWrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

.earningsDateTitleLabel {
  @include typography-v2-title-sm;
  color: var(--text-soft);
}

.earningsDateValueLabel {
  @include typography-v2-body-sm;
  color: var(--text-default);
}

.earningsReactionWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}

.earningsReactionTitleLabel {
  @include typography-v2-title-sm;
  color: var(--text-soft);
}

.earningsReactionValueLabel {
  @include typography-v2-body-sm;
  font-family: var(--font-roboto-mono);
  color: var(--viz-bearish);
}

.earningsReactionValueLabelPositive {
  color: var(--viz-bullish);
}

.descriptionLabel {
  padding-top: 4px;
  padding-bottom: 4px;
  @include typography-v2-body-base;
}

.descriptionLabelReported {
  padding-top: 24px;
}

.relationLabel {
  @include typography-v2-body-sm;
  color: var(--text-soft);
}

.potentialImpactLabel {
  @include typography-v2-body-sm;
  color: var(--text-soft);
}

.tableNameCell {
  min-width: 0;
  flex: 1;
  padding: 6px 12px;
}

.numberCell {
  padding: 6px 12px;
  font-family: var(--font-roboto-mono);
}

.surpriseCell {
  padding: 6px 12px;
  font-family: var(--font-roboto-mono);
  color: var(--viz-bearish);
  background-color: var(--viz-bearish-soft);
}

.surpriseCellPositive {
  color: var(--viz-bullish);
  background-color: var(--viz-bullish-soft);
}

.surpriseCellZero {
  color: var(--text-soft);
  background-color: var(--surface-default);
}

.loaderRoot {
  padding: 16px;
  width: 100%;
}
